<template>
  <div id="event-information-detail">
    <div class="l-shop-deal bg-white pb-38" v-show="!loading">
      <ul class="c-list-deal c-list-deal--xl has-full">
        <li>
          <div class="c-list-deal__item">
            <template v-if="event.image && event.image.length > 0">
              <div class="swiper-container js-swiper_tab_body js-swiper_tab_body-event">
                <div class="swiper-wrapper">
                  <div class="c-list-deal__img swiper-slide js-keep-ratio" data-ratio="0.746" v-for="img in event.image" :key="img">
                    <img v-lazy="getImgSrc(img)" alt="">
                  </div>
                </div>
              </div>
            </template>
            <div v-else>
              <div class="c-list-deal__img js-keep-ratio" data-ratio="0.746">
                <img src="/assets/images/aeontown-noimg.png" alt="">
              </div>
            </div>
            <div class="swiper-pagination swiper-pagination-eventdetail" v-if="event.image && event.image.length > 1"></div>
            <div class="c-list-deal__info" :style="{paddingBottom: qerUrl ? '35px' : '0'}">
              <div class="c-list-deal__info--head mb-12">
                <div class="c-list-deal__shop" @click.prevent="shopTop(event.provider)" v-if="event.provider && event.provider.id != SHOP_ID">
                  <div v-if="event.provider" class="c-list-deal__shop--img">
                    <img v-lazy="getImgSrc(event.provider.image[0])" alt="" />
                  </div>
                  <div v-if="event.provider" class="c-list-deal__shop--name">
                    {{ event.provider.shopName }}
                  </div>
                </div>
                <div class="c-news__shop--name aeon-all" style="font-size: 16px" v-else>
                  イオンタウンイベント
                </div>
                <favorite-icon
                  :isActive="isActive(event.id)"
                  :toggleFavorite="() => toggleFavoriteEvent(event)"
                />
              </div>
              <div class="event-title-detail">
                {{ event.title }}
              </div>
              <div class="postDetail__info-group">
                <div class="postDetail__info">
                  <div class="postDetail-title" v-if="formatEventTerm(event)">実施期間</div>
                  <div class="postDetail-text" v-html="formatEventTerm(event)" />
                </div>
                <div class="postDetail__info" v-if="event.time || event.place">
                  <div class="postDetail-title" v-if="event.time">時間</div>
                  <div class="postDetail-text" v-if="event.time" v-html="formatTimeandPlace(event.time)" />
                  <div class="postDetail-title" v-if="event.place">場所</div>
                  <div class="postDetail-text" v-if="event.place" v-html="formatTimeandPlace(event.place)" />
                </div>
              </div>
              <div class="c-list-deal__info--content">
                <div v-if="event.content" v-html="autolink(event.content)"></div>
                <div v-else v-html="event.title"></div>

                <div v-if="event.qerLoginRequired && qerUrl && !isUserLoggedIn()" class="c-list-deal__info--content">
                  <p class="color-4">こちらのサービスを利用するには、ログインが必要です。</p>
                </div>
                <div v-if="qerUrl" class="btn-fixed-bottom">
                  <router-link v-if="event.qerLoginRequired && !isUserLoggedIn()" to="/account/profile" class="bg-purple center-all-item btn-to-site decoration-none">ログインはこちら</router-link>
                  <a v-else v-bind:href="qerUrl" class="bg-purple center-all-item btn-to-site ext-link decoration-none">アンケートに回答する</a>
                </div>
                <div class="pb-50">
                  <div v-on:click="backList" class="btn-outline center-all-item btn-to-site">戻る</div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <loader :loading="loading" />
    <alert :message="alert_msg" :show="alert_show" :closeModal="closeModal" :confirm_show="confirm_show"
        :confirm_message="confirm_msg" :confirm_callback="confirm_callback" :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel" :label_ok="confirm_label_ok"></alert>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import Swiper, { Pagination } from "swiper";
import { getEventDetail, getShop } from "../store/firestore.js";
import { EVENT_COLLECTION_KEY } from "../config/const.js";
import loader from "../components/parts/loader.vue"
import FavoriteIcon from "../components/FavoriteIcon.vue";
import Alert from "../components/Alert.vue";
const $ = window.$;

Swiper.use(Pagination);

export default Vue.extend({
  name: "EventDetail",
  props: {
    eventId: {
      type: String,
      required: false
    },
    eventProviderId: {
      type: String,
      required: false
    },
    toggleFavoriteEvent: {
      type: Function,
      required: true,
    },
    isActive: {
      type: Function,
      required: true,
    }
  },
  components: {
    FavoriteIcon,
    loader,
    alert: Alert
  },
  mixins: [Tenant],
  data() {
    return {
      event: {},
      qerUrl: "",
      EVENT_COLLECTION_KEY: EVENT_COLLECTION_KEY,
      loading: false,
      swiper: null
    }
  },
  watch: {
    eventId: {
      handler: async function (newVal) {
        if (!newVal) return
        this.loading = true
        const shopId = Common.getUrlParam('shopId');
        if (!shopId || shopId === this.$store.state.shopId) {
          await this.getDateEventDetail(newVal, this.eventProviderId)
        }
        if (this.swiper) this.swiper.destroy()
        this.swiper = new Swiper(".js-swiper_tab_body-event", {
          slidesPerView: 1,
          speed: 400,
          direction: "horizontal",
          observer: true,
          observeParents: true,
          waitForTransition: true,
          pagination: {
            el: ".swiper-pagination-eventdetail",
            clickable: true,
          },
        });
      },
      immediate: true
    }
  },
  async created() {
    let shopId = Common.getUrlParam('shopId');
    if (shopId && shopId != this.$store.state.shopId) {
      const shop = await getShop(shopId);
      const res = await this.confirm(`${shop.name}\n\nこの店舗に表示を切り替える`, false, { ok_label: 'はい', cancel_label: 'いいえ' });
      if (res) {
        await this.$store.dispatch('setShopId', shopId);
        location.reload()
      } else {
        this.$router.push('/top');
      }
    }

    $('.c-list-deal__info--content a').addClass('ext-link');
  },
  mounted() {
    Common.initDom();
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async getDateEventDetail(eventId, eventProviderId) {
      this.loading = true;
      const result = await getEventDetail(eventId, eventProviderId)
      if (!result) return
      this.event = result
      if (this.event.source == 'aeontown.co.jp') {
        $('.c-list-deal__info--content img').addClass('w-100');
      }
      if (this.event.qerUrl) {
        let url = new URL(this.event.qerUrl);
        url.searchParams.append('uid', this.$store.state.userId);
        this.qerUrl = url;
      } else {
        this.qerUrl = "";
      }
      this.loading = false;
    },
    shopTop(provider) {
      if (!provider || !provider.id) return;
      this.$router.push('/shop/list?id=' + provider.id);
    },
    formatTimeandPlace(str) {
      return str?.replace(/(\s|　)+/g, "<br />");
    },
    backList() {
      this.$emit('navigateBack');
    },
  }
})
</script>
